<template>
  <modal
    ref="modal"
    class="business-status-modal"
    title="Configurações do Negócio"
    :showModal="true"
    @close="closeModal"
  >
    <template v-slot:body>
      <div class="modal-body">
        <business-status-card
          @snackbarNotification="handleSnackbarNotification"
        />
      </div>
    </template>

    <template v-slot:footer>
      <div class="footer-container">
        <button-component
          class="button-component"
          text="Fechar"
          styles="ghost"
          @click.native="closeModal"
        />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/Base';
import Button from '@/components/Base/Button';
import BusinessStatusCard from './BusinessStatusCard';

export default {
  name: 'BusinessStatusModal',

  components: {
    'modal': Modal,
    'button-component': Button,
    'business-status-card': BusinessStatusCard
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    handleSnackbarNotification(text, color) {
      this.$emit('snackbarNotification', text, color);
    }
  }
};
</script>

<style lang="scss" scoped>
.business-status-modal {
  .modal-body {
    padding: 0;
    width: 600px;
    max-height: 70vh;
    overflow-y: auto;

    .business-status-card {
      margin-bottom: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .footer-container {
    display: flex;
    justify-content: flex-end;
    padding: 0.75rem 1rem;
    box-shadow: 0px -1px 6px rgba(0, 0, 0, 0.08);

    .button-component {
      width: 100px;
      height: 48px;
    }
  }
}

@media (max-width: 767px) {
  .business-status-modal {
    .modal-body {
      width: 100%;
    }
  }
}
</style> 